var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayblackicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16.4289V4.92992C4 4.1191 4.91427 3.64537 5.57668 4.11295L13.2427 9.52425C13.7877 9.90899 13.8103 10.7094 13.2879 11.1243L5.62188 17.212C4.96655 17.7324 4 17.2658 4 16.4289Z",
    stroke: "#111111",
    strokeWidth: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayblackicon);
export default __webpack_public_path__ + "static/media/playblackicon.ab99fdc21b594bbc7507d39b8f4c94b8.svg";
export { ForwardRef as ReactComponent };